<template>
  <select-input v-model="clientName" :select-list="clients" />
</template>

<script setup lang="ts">
import { defineModel, computed, watch } from "vue";
import { useNewEstimateStore } from "@/stores/new/estimateStore";

import SelectInput from "@/components/UI/SelectInput.vue";
import { useDictStore } from "@/stores/dictStore";

const dictStore = useDictStore();

const clientName = defineModel<string>({ default: "" });
const clients = dictStore.getClients();
const managers = dictStore.getManagers();
const estimateStore = useNewEstimateStore();
const isShippingAndBillingEqual = computed(() => estimateStore.estimate.isShippingAndBillingEqual);

watch(
  () => clientName.value,
  (val, prevValue) => {
    if (prevValue === "") {
      const clientInfo = clients.find((client) => client.title === val);
      estimateStore.estimate.client.businessName =
        clientInfo?.business_name || "";
      estimateStore.estimate.client.email = clientInfo?.email || "";
      estimateStore.estimate.client.phone = clientInfo?.phone || "";
      estimateStore.estimate.client.billingAddress =
        clientInfo?.billing_address || "";
      estimateStore.estimate.client.billingZip = clientInfo?.zip_code || "";
      estimateStore.estimate.client.billingState =
        clientInfo?.state || "";

      if (isShippingAndBillingEqual.value) {
        estimateStore.estimate.client.shippingAddress =
          clientInfo?.billing_address || "";
        estimateStore.estimate.shippingZip = clientInfo?.zip_code || "";
        estimateStore.estimate.shippingState =
          clientInfo?.state || "";
      }

      if (!val || !clientInfo?.manager_id) {
        estimateStore.estimate.managerCode = null;
        return;
      }
      const clientManagerCode = managers.find((manager) => manager.id === clientInfo.manager_id);
      estimateStore.estimate.managerCode = clientManagerCode || null;
    }
  },
  {
    deep: true,
    immediate: true,
  },
);
</script>

<style lang="scss" scoped></style>
